import './styles.scss'
import React from 'react'

import MessageTitle from 'components/Chat/DisplayNameMsg/MessageTitle'

/**
 * Return a Component InReplyTo
 * @param {object} props
 * @param {string} props.text
 * @param {string} props.messageSender
 * @param {string} [props.typeTitle]
 * @param {[object]} [props.attachments]
 * @param {object} [props.postedBy]
 * @param {string} [props.postedBy.name]
 * @param {string} [props.postedBy.email]
 * @returns {Component}
 */
function InReplyToMsg (props) {
  const {
    postedBy = {}, attachments = [], text = '',
    messageSender, typeTitle
  } = props

  const attachmentType = checkAttachmentType({ attachments })
  const classnameMain = getClassName({ attachmentType })

  return (
    <div className={`in-reply-to ${classnameMain}`}>
      <div className='in-reply-to__content'>
        <InReplyToPostBy
          messageSender={messageSender}
          postedBy={postedBy || {}}
          typeTitle={typeTitle}
        />
        <TextContent
          attachmentType={attachmentType}
          text={text}
        />
      </div>
      <InReplyToAttachment
        attachmentType={attachmentType}
        attachments={attachments}
      />
    </div>
  )
}

/**
 * Return InReplyToPostBy
 * @param {object} props
 * @param {string} props.messageSender
 * @param {{name: string, email: string}} props.postedBy
 * @param {string} [rops.typeTitle]
 *
 * @returns {Component}
 */
function InReplyToPostBy({ messageSender, postedBy, typeTitle }) {
  const name = postedBy.name

  return (
    <p className='in-reply-to__posted-by'>
      {
        name
          ? name
          : (
            <MessageTitle
              type={messageSender}
              user={{ name: postedBy.name }}
              operatorName={{ name: postedBy.name }}
              typeTitle={typeTitle}
            />
          )
      }
    </p>
  )
}

/**
 * Return TextCotent
 * @param {object} props
 * @param {string} [props.attachmentType]
 * @param {string} props.text
 *
 * @returns {Component}
 */
function TextContent({ attachmentType, text }) {
  if (attachmentType === 'audio') return null
  if (!text) return null

  return <p className='in-reply-to__message'>{text}</p>
}

/**
 * Return InReplyToAttachment
 * @param {object} props
 * @param {string} props.attachmentType
 * @param {[object]} props.attachments
 *
 * @returns {Component}
 */
function InReplyToAttachment(props) {
  const { attachmentType, attachments } = props
  if (!attachments || !attachments.length || !attachmentType) return null

  return (
    <div className={`in-reply-to__attachments ${attachmentType === 'audio' ? 'in-reply-to__attachments--audio' : ''}`}>
      <AttachmentContent
        attachment={attachments[0]}
        attachmentType={attachmentType}
      />
    </div>
  )
}

/**
 * Return AttachmentContent
 * @param {object} props
 * @param {string} props.attachmentType
 * @param {object} props.attachment
 *
 * @returns {Component}
 */
function AttachmentContent({ attachmentType, attachment }) {
  const { url, urlLong, mimeType, mimeSubtype, thumb } = attachment
  const rightUrl = urlLong || url

  if (attachmentType === 'image') {
    return (
      <img className='in-reply-to__attachment' src={rightUrl} alt={`Attachment ${url}`} />
    )
  }

  if (attachmentType === 'video') {
    return (
      <video className='in-reply-to__attachment'>
        <source src={rightUrl} type={`${mimeType}/${mimeSubtype}`} />
        Your browser does not support the video tag.
      </video>
    )
  }

  if (attachmentType === 'audio') {
    return (
      <audio controls>
        <source src={rightUrl} type='audio/ogg' />
        Your browser does not support the audio element.
      </audio>
    )
  }

  if (attachmentType === 'pdf') {
    return (
      <img className='in-reply-to__attachment' src={thumb || './img/pdf-default.png'} alt={`Attachment ${url}`} />
    )
  }

  return null
}

/**
 * Return clasName
 * @param {object} data
 * @param {string} data.attachmentType
 *
 * @returns {string}
 */
function getClassName(data) {
  const { attachmentType } = data

  if (attachmentType === 'audio') return 'in-reply-to--audio'

  return ''
}

/**
 * Return first attachment type
 * @param {object} data
 * @param {[object]} data.attachments
 *
 * @returns {'audio'|'pdf'|'image'|'video'}
 */
function checkAttachmentType(data) {
  const { attachments = [] } = data
  if (!attachments || !attachments.length) return ''

  const { mimeType, mimeSubtype } = attachments[0]
  if (mimeType === 'audio') return 'audio'
  if (mimeType === 'image') return 'image'
  if (mimeType === 'video') return 'video'
  if (mimeSubtype === 'pdf') return 'pdf'

  return ''
}

export default InReplyToMsg